<script>
  import bootbox from '../bootbox.min';
  import IntersectionObserver from '../intersection-observer-polyfill';

  export default {
    template: '#data-list',
    props: {
      dataSource: {
        type: String,
      },

      identifier: {
        default: '',
      },

      urlCreate: {
        type: String,
        default() {
          return null;
        },
      },

      deleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja apagar este registro?';
        },
      },

      resendMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja reenviar este e-mail?';
        },
      },

      undeleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja restaurar este usuário?';
        },
      },

      deleteTitle: {
        type: String,
        default() {
          return 'Excluir registro';
        },
      },

      resendTitle: {
        type: String,
        default() {
          return 'Reenviar e-mail';
        },
      },

      undeleteTitle: {
        type: String,
        default() {
          return 'Restaurar';
        },
      },

      baseCounter: {
        type: Number,
        default: () => 0,
      }
    },

    watch: {
      dataSource() {
        this.fetchData();
      },

      query: _.debounce(function(text) {
        this.currentPage = 1;
        this.items = [];
        this.fetchData();
      }, 350),

      'filters.status': function() {
        this.setFilter('status', this.filters.status);
        this.fetchData();
      },

      toggleAll(value) {
        this.selectedItems = (value)
          ? this.items.map((item) => item.id)
          : [];
      }
    },

    computed: {
      queryFilters() {
        let query_filters = '';
        for (var filterName in this.filters) {
          if (this.filters.hasOwnProperty(filterName)) {
            query_filters += '&' + filterName + '=' + this.filters[filterName];
          }
        }
        return query_filters;
      },

      fetch_url() {
        let query_params = '';
        query_params = '?query=' + this.query;
        query_params += '&field=' + this.field;
        query_params += '&order=' + this.order;

        if (this.currentPage != 1) {
          query_params += '&page=' + this.currentPage;
        }

        query_params += this.queryFilters;

        const url = this.dataSource + query_params;
        return encodeURI(url);
      },

      no_results() {
        return typeof this.items == 'undefined' || this.items.length == 0;
      },

      enabledNextPageButton() {
        return this.currentPage < this.totalPages;
      },

      enabledPrevPageButton() {
        return this.currentPage > 1;
      },

      shouldShowPagination() {
        return this.totalPages > 1;
      },

      isNotLoading() {
        return !this.loading;
      },
    },

    data: function() {
      return {
        items: [],

        selectedItems: [],

        loading: true,

        query: '',
        field: '',
        order: 'desc',

        total: 0,

        totalPages: 1,
        currentPage: 1,
        itemsPerPage: 15,

        count: {
          actives: 0,
          inactives: 0,
        },

        filters: {},

        toggleAll: false,
      };
    },

    mounted() {
      this.listenFilters();
      this.listenLoadingEvents();
      this.fetchData();
      this.$root.$on('reload-data', () => this.fetchData());
      this.$root.$on('refresh-data-list', () => {
        this.selectedItems = [];
        this.items = [];
        this.fetchData();
      });
    },

    methods: {
      showModalForSelectedItems(modalName) {
        if (this.selectedItems.length === 0) {
          return bootbox.alert('Selecione ao menos um item da lista...');
        }
        $(modalName).modal('show');
      },
      
      getBadgeColorById(id) {
        let classes = ['dark', 'danger', 'warning', 'info', 'success', 'primary'];
        return classes[id % classes.length];
      },

      orderBy(field, event) {
        this.field = field;
        this.items = [];
        this.toggleOrder();
        this.setOrderArrowIn(event.target);
        this.fetchData();
      },

      toggleOrder() {
        this.order = (this.order == 'asc') ? 'desc' : 'asc';
        return this.order;
      },

      setOrderArrowIn(element) {
        let defaultClass = '.order-arrow';
        let classToRemove = $(element).attr('class');

        let toQuery = classToRemove ? `.${classToRemove} > .order-arrow` : defaultClass;

        let arrows = Array.from(document.querySelectorAll(toQuery));

        arrows.forEach((node) => {
          node.parentNode.removeChild(node);
        });

        element.appendChild(this.getArrow());
      },

      getArrow() {
        let arrow_classes = '';
        if (this.order == 'asc') {
          arrow_classes = 'fa fa-angle-up order-arrow';
        } else {
          arrow_classes = 'fa fa-angle-down order-arrow';
        }

        const arrow = document.createElement('i');
        arrow.className = arrow_classes;

        return arrow;
      },

      getRef(ref) {
        return this.$refs[ref];
      },

      setPagination(fetched_data) {
        if (typeof fetched_data !== 'undefined') {
          if (fetched_data.meta !== undefined) {
            this.totalPages = fetched_data.meta.last_page;
            this.currentPage = fetched_data.meta.current_page;
            this.itemsPerPage = fetched_data.meta.per_page;
            this.total = fetched_data.meta.total;
          } else {
            this.totalPages = fetched_data.last_page;
            this.currentPage = fetched_data.current_page;
            this.itemsPerPage = fetched_data.per_page;
          }
        }
      },

      fetchData() {
        const vm = this;
        this.$root.$emit('start-loading');
        const localQuery = this.query;
        axios.get(this.fetch_url).then((response) => {
          if (localQuery === this.query) {
            this.items = _.union(this.items, response.data.data);
            this.setPagination(response.data);
            this.$root.$emit('stop-loading');
            this.$nextTick().then(function() {
              let div = $('[data-toggle="popover"]')
              if (div)
                div.popover();

              vm.$root.lazyImages();
            });
          }
        });
      },

      fetchPrevPage() {
        if (this.enabledPrevPageButton) {
          this.currentPage = this.currentPage - 1;
          this.fetchData();
        }
      },

      fetchNextPage() {
        if (this.enabledNextPageButton) {
          this.currentPage = this.currentPage + 1;
          this.fetchData();
        }
      },

      handleDelete(link) {
        axios.delete(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$root.throwFlashMessage(status.type, status.message);
            this.items = [];
            this.fetchData();
          } else {
            this.$root.throwFlashMessage('danger', 'Houve um problema ao remover a coordenada');
          }
        });
      },

      handleResendEmail(link) {
        axios.get(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      confirmDelete(link, message = undefined) {
        if (message == undefined) {
          message = this.deleteMessage;
        }

        bootbox.confirm(message, (result) => {
          if (result)
            this.handleDelete(link);
        });
      },

      listenFilters() {
        this.$on('setFilter', (payload) => {
          this.setFilter(payload.urlKey, payload.value);
          this.items = [];
          this.fetchData();
        });
      },

      setFilter(name, value) {
        if (value) {
          this.$set(this.filters, name, value);
        } else {
          delete this.filters[name];
          this.filters = _.assign({}, this.filters);
        }
      },

      listenLoadingEvents() {
        const vm = this;
        const target = document.querySelector('footer');
        let observer = new IntersectionObserver(onIntersection, {});

        observer.observe(target);

        function onIntersection(entries){
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
              vm.fetchNextPage();
            }
          });
        }

        this.$root.$on('start-loading', () => {
          this.loading = true;
        });

        this.$root.$on('stop-loading', () => {
          this.loading = false;
        });
      },

      toggleSelected(item) {
        if (this.selectedItems.includes(item)) {
          this.selectedItems = this.selectedItems.filter((selected) => selected != item);
        } else {
          this.selectedItems.push(item);
        }
      },

      multipleConfirm(message, url) {
        if (this.selectedItems.length === 0)
          return bootbox.alert('Selecione ao menos um item para excluir');

        bootbox.confirm(message, (result) => {
          if (result) {
            axios.post(url, {
              items: this.selectedItems,
            }).then((response) => {
              this.$root.throwFlashMessage(response.data.type, response.data.message);
            }).catch(() => {
              this.$root.throwFlashMessage('danger', 'Houve um problema ao excluir os itens');
            }).finally(() => {
              this.items = [];
              this.selectedItems = [];
              this.fetchData();
            });
          }
        });
      },

      destroyAll(message, url) {
        bootbox.confirm(message, (result) => {
          if (result) {
            axios.post(url).then((response) => {
              this.$root.throwFlashMessage(response.data.type, response.data.message);
            }).catch(() => {
              this.$root.throwFlashMessage('danger', 'Houve um problema ao excluir os itens');
            }).finally(() => {
              this.items = [];
              this.selectedItems = [];
              this.fetchData();
            });
          }
        });
      },

      renewTemplates() {
        if(this.selectedItems.length === 0)
          return bootbox.alert('Selecione ao menos uma coordenada para renovar');

        this.$root.$emit('show-renew-templates-modal', this.selectedItems);
      },

      renewThemes() {
        if(this.selectedItems.length === 0)
          return bootbox.alert('Selecione ao menos uma campanha para renovar');

        this.$root.$emit('show-renew-themes-modal', this.selectedItems);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/InfinityScroll.vue